var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTooltipIconHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6132_75686)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6132_75686",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6132_75686)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_6132_75686",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 16,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_6132_75686)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.9966 6.8001C10.1656 6.8001 10.3084 6.74293 10.4251 6.6286C10.5418 6.51426 10.6001 6.3726 10.6001 6.2036C10.6001 6.0346 10.5429 5.89176 10.4286 5.7751C10.3143 5.65843 10.1726 5.6001 10.0036 5.6001C9.8346 5.6001 9.69176 5.65726 9.5751 5.7716C9.45843 5.88593 9.4001 6.0276 9.4001 6.1966C9.4001 6.3656 9.45726 6.50843 9.5716 6.6251C9.68593 6.74176 9.8276 6.8001 9.9966 6.8001ZM9.9966 12.0001C10.1656 12.0001 10.3084 11.9426 10.4251 11.8276C10.5418 11.7126 10.6001 11.5701 10.6001 11.4001V8.2001C10.6001 8.0301 10.5429 7.8876 10.4286 7.7726C10.3143 7.6576 10.1726 7.6001 10.0036 7.6001C9.8346 7.6001 9.69176 7.6576 9.5751 7.7726C9.45843 7.8876 9.4001 8.0301 9.4001 8.2001V11.4001C9.4001 11.5701 9.45726 11.7126 9.5716 11.8276C9.68593 11.9426 9.8276 12.0001 9.9966 12.0001ZM6.0001 14.0001L4.61876 15.3814C4.42854 15.5717 4.21121 15.6145 3.96676 15.5099C3.72232 15.4055 3.6001 15.2189 3.6001 14.9501V4.8001C3.6001 4.4701 3.7176 4.1876 3.9526 3.9526C4.1876 3.7176 4.4701 3.6001 4.8001 3.6001H15.2001C15.5301 3.6001 15.8126 3.7176 16.0476 3.9526C16.2826 4.1876 16.4001 4.4701 16.4001 4.8001V12.8001C16.4001 13.1301 16.2826 13.4126 16.0476 13.6476C15.8126 13.8826 15.5301 14.0001 15.2001 14.0001H6.0001ZM5.5001 12.8001H15.2001V4.8001H4.8001V13.5001L5.5001 12.8001Z",
    fill: "#9F004F"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6132_75686"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipIconHover);
export default __webpack_public_path__ + "static/media/tooltip-icon-hover.1733692f5cdba53326e8b23a3d03ae26.svg";
export { ForwardRef as ReactComponent };